// import { scan } from 'react-scan';
import React, { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './styles/global.css';
import './styles/styles.css';
import './i18n';
import HomeLoadingWrapper from '@components/LoaderPages/HomeLoaderWrapper';
import { appThemeConfiguration, HomeLoadingTemplate } from '@appConfig';

// scan({
//   enabled: true,
// });
const queryClient = new QueryClient();
const AppWrapper = React.lazy(() => import('./AppWrapper'));

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

if (import.meta.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept();
}

root.render(
  <StrictMode>
    <Router>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Suspense
            fallback={
              <HomeLoadingWrapper template={appThemeConfiguration.HOME_LOADING_VERSION} />
            }
          >
            <AppWrapper />
          </Suspense>
        </Provider>
      </QueryClientProvider>
    </Router>
  </StrictMode>
);
